import './style.scss'
import React, { useState, useEffect, useContext } from 'react'
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import helpers from 'src/utils/helpers';
import DataTable from 'react-data-table-component';
import {customStyles, customHeadStyles} from './style'
import { AppSpan, AppText, Button, CustomContainer, FlexColumn, FlexRow, GridContainer, Input } from 'src/style';
import { FiSearch } from 'react-icons/fi';
import {ReactComponent as NoDataIcon} from 'src/assets/img/no-data-icon.svg'
import {ReactComponent as NoDataIconD2} from 'src/assets/img/no-data-icon-d2.svg'
import {ReactComponent as NoDataIconD3} from 'src/assets/img/no-data-icon-d3.svg'
import { Design } from 'src/model'

export const Table: React.FC<any> = React.memo(({
    tableData, tableColumns, resetPagination, 
    customStyle, hasRowSelection, onRowSelectedMethod,
    noRadius, canSearch, onRowClickMethod, noDataText,
    noDataActionComponent, paginationPerPage
}) => {
    const {info: {institutionData}} = useContext(AppInfoContext)
    const [mockTableData, setMockTableData] = useState<any[]>([])

    useEffect(() => {
        setMockTableData(tableData)
    }, [tableData])

    function handleDataSearching (e: React.ChangeEvent<HTMLInputElement>) {
        const filteredData = helpers.searchTableData(tableData, e.target.value)
        console.log({filteredData})
        setMockTableData(filteredData)
    }

  return (
    <>
       { tableData ?
            <>
                { canSearch &&
                    <CustomContainer 
                        width='30' radius='0.4' borderColor='#E2E8F0' 
                        leftPadding='1.5' rightPadding='1.5'
                        bgColor='#ffffff' rightMargin='1.5'
                    >
                        <FlexRow>
                            <FiSearch style={{fontSize: '2rem', color: '#A0AEC0'}} />
                            <Input 
                                height='4' leftPadding='1' placeholder='Search' color='#718096' 
                                onChange={handleDataSearching} 
                            />
                        </FlexRow>
                    </CustomContainer>
                }
                <div className={ noRadius ? "table-wrapper-no-radius" : "table-wrapper"} >
                    <DataTable
                        columns={tableColumns}
                        data={mockTableData?.length ? mockTableData : tableData}
                        paginationResetDefaultPage={resetPagination}
                        //striped={true}
                        onRowClicked={onRowClickMethod}
                        selectableRows={hasRowSelection}
                        onSelectedRowsChange={hasRowSelection ? onRowSelectedMethod : null}
                        pagination
                        paginationPerPage={paginationPerPage || 10}
                        customStyles={customStyle ? customStyles  : undefined}
                        noDataComponent={
                            <NoTableData 
                                noDataText={noDataText} 
                                actionComponent={noDataActionComponent} 
                                institutionData={institutionData}
                            />
                        }
                    />
                </div>
            </>
            : 
            <NoTableData 
                noDataText={noDataText} 
                institutionData={institutionData}
            />
        }
    </>
  )
})

export const NoTableData: React.FC<any> = ({noDataText, actionComponent, institutionData}) => {
    return (
        <GridContainer height='33.2' style={{borderTop: '1px solid #EAECF0'}}>
            <FlexColumn width="auto" sizeUnit="">
                { institutionData.design === Design.DESIGN_1 ?
                    <NoDataIcon className="icon-component" />
                    : institutionData.design === Design.DESIGN_2 ?
                        <NoDataIconD2 />
                        : <NoDataIconD3/>
                }
                <AppText textSize="1.6" fontWeight="600" color="#101828" align="center" topMargin="1.5">
                    {noDataText || 'No Records'}
                </AppText>
                {actionComponent && actionComponent}
            </FlexColumn>
        </GridContainer>
    )
}